import { render, staticRenderFns } from "./puntos2.vue?vue&type=template&id=79d0fc38&"
import script from "./puntos2.vue?vue&type=script&lang=js&"
export * from "./puntos2.vue?vue&type=script&lang=js&"
import style0 from "./puntos2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports